export default __webpack_public_path__ + "static/media/articles1.fb2cd54b.jpg";